import type { UpdateNotificationAlertRequest } from '@weft/api-definition';
import { NotificationAlertSchema, type NotificationAlert } from '@weft/types';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { USE_NOTIFICATIONS_QUERY_KEY } from './use-get-notifications';

type MutationInputType = {
  notificationAlertId: string;
  updateNotificationAlertStatusRequest: UpdateNotificationAlertRequest;
};

export function useUpdateNotificationAlertStatus(options?: UseMutationOptions<NotificationAlert, unknown, MutationInputType, unknown>) {
  const queryClient = useQueryClient();

  return useMutation(async ({ notificationAlertId, updateNotificationAlertStatusRequest }) => {
    const invoicesApi = getPrivateApi();
    const updateNotificationAlertStatusResponse = await invoicesApi.updateNotificationAlertStatus({ updateNotificationAlertStatusRequest, notificationAlertId });
    await queryClient.invalidateQueries(USE_NOTIFICATIONS_QUERY_KEY);

    return NotificationAlertSchema.parse(updateNotificationAlertStatusResponse);
  },
  options,
  );
}